import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../models/reduxState';
import { RequestHistory } from '../../presentationalComponents/RequestHistory/RequestHistory';
import { dispatchSearchRequests, dispatchSignInUserIntoClientApp } from '../../reduxUpdater/dispatchers/contactUsDispatchers';
import { isUnifiedPremierSelector, isUnifiedEnterprisePremierSelector, isNonUnifiedPremierSelector, isPremierTenantSelector } from '../../reduxUpdater/selectors/globalStateSelectors';
import { allRequestsSelector } from '../../reduxUpdater/selectors/requestHistorySelectors';
import { isRequestHistoryEnabledSelector } from '../../reduxUpdater/selectors/requestSelector';
import { getRequestHistoryStyles } from '../../styles/requestHistoryStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    isSignedIn: state.ContactState.ModalitySectionState.isSignedIn,
    isRequestHistoryEnabled: isRequestHistoryEnabledSelector(state),
    allRequests: allRequestsSelector(state),
    isOrgId: state.ContactState.ModalitySectionState.isOrgId,
    isUserSigningIntoClientApp: state.ContactState.ModalitySectionState.isUserIsSigningIntoClientApp,
    isAdmin: state.ContactState.ModalitySectionState.isAdmin,
    isUnifiedPremier: isUnifiedPremierSelector(state),
    isUnifiedEnterprisePremier: isUnifiedEnterprisePremierSelector(state),
    isNonUnifiedPremier: isNonUnifiedPremierSelector(state),
    isPremierTenantEnabled: isPremierTenantSelector(state),
  };
};

const mapDispatchToProps = {
  dispatchSearchRequests,
  dispatchSignInUserIntoClientApp,
};

export const RequestHistoryContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(RequestHistory, getRequestHistoryStyles));
